import { useContext } from 'react';
import Checkbox from '../../Checkbox/Checkbox';
import { ConfigurationContext, DispatchContext } from './ConfigurationContext';
import {
  isCheckboxSelected,
  isHeaterDisabled,
  isUpgradeDisabled,
} from './utils';
import FieldGroup from '../../FieldGroup/FieldGroup';

const FormStepHeaters = ({ heaterField, upgradesField }) => {
  const {
    size,
    heaters: { heater, upgrades },
  } = useContext(ConfigurationContext);
  const dispatch = useContext(DispatchContext);

  const isHeaterSelected = (option) => option.id === heater?.id;

  const handleHeaterChange = (option) => {
      dispatch({ type: 'SELECT_HEATER', payload: {option, upgrades: upgradesField.options} });
  };

  const handleUpgradeChange = (option, checked) => {
    dispatch({ type: 'SELECT_HEATER_UPGRADE', payload: { option, checked } });
  };

  const heaterGroupId = `${heaterField.name}-radio-group`;
  const upgradesGroupId = `${upgradesField.name}-radio-group`;

  return (
    <>
      <FieldGroup
        title={heaterField.title}
        id={heaterGroupId}
        details={heaterField.details}
      >
        {heaterField.options.map((option) => (
          <Checkbox
            key={option.id}
            type="radio"
            name={heaterGroupId}
            isChecked={isHeaterSelected(option)}
            isDisabled={isHeaterDisabled(option, size)}
            {...option}
            onChange={handleHeaterChange}
          />
        ))}
      </FieldGroup>

      <FieldGroup title={upgradesField.title} id={upgradesGroupId}>
        {upgradesField.options.map((option) => (
          <Checkbox
            key={option.id}
            name={upgradesGroupId}
            isChecked={isCheckboxSelected(option, upgrades)}
            isDisabled={!heater || isUpgradeDisabled(option, heater)}
            {...option}
            onChange={handleUpgradeChange}
          />
        ))}
      </FieldGroup>
    </>
  );
};

export default FormStepHeaters;
